import axios from "axios";

export const http = axios.create({
    timeout: 30000,
});

export const onSuccess = ({ data }) => data;
export const onFail = ({ response: { data } }) => {
    throw data;
};

export const formDataBuilder = (
    data,
    formData = new FormData(),
    parentKey = null
) => {
    Object.entries(data).forEach(([key, value]) => {
        if (typeof value === "undefined" || typeof value === null) return;

        const formattedKey = !parentKey ? key : `${parentKey}[${key}]`;

        if (value instanceof File) {
            formData.append(formattedKey, value);

            return;
        }

        if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
                formData.append(`${formattedKey}[]`, value[i]);
            }

            return;
        }

        if (
            !Array.isArray(value) &&
            typeof value === "object" &&
            value !== null
        ) {
            formData = formDataBuilder(value, formData, formattedKey);

            return;
        }

        formData.append(formattedKey, value);
    });

    return formData;
};
